
	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';

	@Component({})
	export default class Error404 extends BaseView {

		public message: string = `Couldn't find the page you were looking for`;
		public image: string = 'http://localhost:5000/Assets/Stubs/default-deck.jpg';

		public mounted() {
			const type = this.$route.query.type;
			if (type) {
				switch (type) {
					case 'deck': 
						this.message = `Couldn't find the deck you were looking for`; 
						this.image = `${this.settings.baseUrl}/Assets/Stubs/default-deck.jpg`;
						break;
					case 'company': 
						this.message = `Couldn't find the company you were looking for`; 
						this.image = `${this.settings.baseUrl}/Assets/Stubs/default-company.jpg`;
						break;
					case 'pro': 
						this.message = `Couldn't find the pro you were looking for`; 
						this.image = `${this.settings.baseUrl}/Assets/Stubs/default-pro.jpg`;
						break;
					case 'artist': 
						this.message = `Couldn't find the artist you were looking for`; 
						this.image = `${this.settings.baseUrl}/Assets/Stubs/default-artist.jpg`;
						break;
					case 'series': 
						this.message = `Couldn't find the series you were looking for`; 
						this.image = `${this.settings.baseUrl}/Assets/Stubs/default-series.jpg`;
						break;
				}
			}
		}

	}

